'use client';
import * as React from "react";
const SkeletonContext = React.createContext(undefined);
const skeletonContextDefaultValue = {};
export const SkeletonContextProvider = SkeletonContext.Provider;
export const useSkeletonContext = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(SkeletonContext)) !== null && _React_useContext !== void 0 ? _React_useContext : skeletonContextDefaultValue;
};
